// Meta (Facebook) Pixel integration
// Pixel ID: 517991158551582

const PIXEL_ID = '517991158551582'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base code and fires the initial PageView.
 * Safe to call multiple times — only runs once.
 */
export function initMetaPixel(): void {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode?.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')

  // <noscript> fallback tracking image — guarantees Meta / Pixel Helper
  // detection even if the fbevents.js script is blocked or delayed.
  if (!document.getElementById('meta-pixel-noscript')) {
    const img = document.createElement('img')
    img.id = 'meta-pixel-noscript'
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.alt = ''
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    document.body.appendChild(img)
  }
}

/**
 * Track a standard Meta Pixel event (e.g. 'InitiateCheckout', 'Lead').
 */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}
